import type React from "react";

export const ThrowballIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 192.419 203.68"
      fill={color}
      {...restProps}
    >
      <title>Throwball Icon</title>
      <path d="M187.153 53.269c-41.11-14.965-75.654-16.473-85.026-16.589a24.611 24.611 0 0 1-7.636 7.077c-1.188 3.002-3.466 5.675-6.641 7.369-6.615 3.529-14.594 1.509-18.042-4.478l-9.684 3.596c-.138.053-.277.128-.415.194-.469.121-.934.28-1.389.491L31.124 63.585c-1.742-3.637-3.958-8.258-6.179-12.878a4767.576 4767.576 0 0 0-4.103-8.516c-8.203-1.11-15.007-6.673-17.893-14.171a8.006 8.006 0 0 0-1.733 10.445c1.647 3.188 12.327 25.433 18.891 39.164a8.002 8.002 0 0 0 7.223 4.552 7.97 7.97 0 0 0 3.37-.749l27.79-12.934c10.242 12.935 14.786 23.299 13.334 48.849-.111 1.112-.381 2.543-.621 4.032-.134.443-.25.895-.336 1.361l-5.47 29.587 23.95 7.967 6.103-33.009a12.53 12.53 0 0 0 .187-2.838.494.494 0 0 1 .036-.011c.803.505 1.668.935 2.604 1.256l36.951 12.654 17.858-20.31-36.727-12.578c1.884-19.393 2.714-33.719-2.21-52.099 14.812 1.259 39.739 4.83 67.532 14.947a7.977 7.977 0 0 0 2.736.484 8.002 8.002 0 0 0 2.736-15.521zM6.491 42.079zM64.599 156.64l-40.385 22.633c-6.022 3.375-8.168 10.993-4.793 17.016a12.497 12.497 0 0 0 17.016 4.793l45.5-25.499a12.498 12.498 0 0 0 6.181-8.632l.497-2.687-23.95-7.967zM140.244 140.062l11.449 53.721c1.252 5.874 6.439 9.897 12.213 9.897.863 0 1.74-.091 2.618-.277 6.752-1.439 11.059-8.079 9.62-14.831l-12.925-60.646c-.762-3.576-3.053-6.581-6.192-8.316l-17.705 20.137z" />
      <circle cx="23.86" cy="20" r="20" />
      <circle
        cx="82.067"
        cy="22.643"
        r="22.5"
        transform="rotate(-7.81 82.23 22.675)"
      />
    </svg>
  );
};
